import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import type { Wishlist } from "@wishlist-hub/shared";
import { Card } from "../components/ui";
import { api } from "../services/api";
import { useAuthStore } from "../stores/authStore";

export function UserWishlists() {
  const { user, loading } = useAuthStore();
  const [list, setList] = useState<Wishlist[] | null>(null);

  useEffect(() => {
    if (!user) return;
    api.get<Wishlist[]>(`/users/${user.id}/wishlists`).then(({ data }) => setList(data));
  }, [user]);

  if (loading) return <p className="text-slate-400">…</p>;
  if (!user) return <Navigate to="/auth/login" replace />;

  return (
    <>
      <Helmet>
        <title>Мои списки — WishList Hub</title>
      </Helmet>
      <h1 className="text-2xl font-bold text-white mb-6">Мои списки</h1>
      {!list ? (
        <p className="text-slate-400">Загрузка…</p>
      ) : list.length === 0 ? (
        <p className="text-slate-500">Пока нет привязанных списков.</p>
      ) : (
        <ul className="space-y-3">
          {list.map((w) => (
            <li key={w.id}>
              <Card>
                <Link to={`/wishlist/${w.slug}`} className="text-lg font-medium text-violet-400 hover:underline">
                  {w.title}
                </Link>
                <p className="text-xs text-slate-500 mt-1">/{w.slug}</p>
              </Card>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
